import ErrorFilled16 from '@carbon/icons-react/es/error--filled/16';
import styled from 'styled-components';

const Wrapper = styled.div`
  color: var(--red-50);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorIcon = (): React.JSX.Element => {
  return (
    <Wrapper>
      <ErrorFilled16 />
    </Wrapper>
  );
};
